import React from 'react';

import { useTranslation } from 'react-i18next';

import { noop } from 'helpers';
import { useWindowSize } from 'hooks';
import { CrossIconSymbol, GreenCircleTick } from 'styles/assets/icons';
import { MaterialConfirmDialog } from 'UIKit';
import Box from 'UIKit/Box';
import DeltaButton from 'UIKit/DeltaButton';

import styles from './style.module.scss';

const OtpSuccessModal = ({ onClose, open }) => {
  const { t } = useTranslation(['account', 'common']);
  const { isMobile } = useWindowSize();

  return (
    <MaterialConfirmDialog
      onClose={onClose}
      open={open}
      transition={false}
      showFooter={false}
      showHeader={false}
      fullWidth={isMobile}
      containerClassName={styles.dialogCointaner}
    >
      <Box
        data-testid="crossIconContainer"
        className={styles.iconContainer}
        onClick={onClose}
        onKeyPress={noop}
        role="button"
        tabIndex={0}
      >
        <CrossIconSymbol color="var(--main-text-secondary)" />
      </Box>
      <GreenCircleTick width={60} height={60} className={styles.greenTickIcon} />
      <p className={styles.successText}>
        {t('account:profile.phoneNoVerificationSuccessMessage')}
      </p>
      <Box className={styles.footer}>
        <DeltaButton
          onClick={onClose}
          variant="primary-t2"
          className={styles.okBtn}
          data-testid="ok-button"
          text={t('common:ok')}
        />
      </Box>
    </MaterialConfirmDialog>
  );
};

export default OtpSuccessModal;
